import { render, staticRenderFns } from "./file-preivew-item.vue?vue&type=template&id=285c7d03&scoped=true&"
import script from "./file-preivew-item.vue?vue&type=script&lang=js&"
export * from "./file-preivew-item.vue?vue&type=script&lang=js&"
import style0 from "./file-preivew-item.vue?vue&type=style&index=0&id=285c7d03&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285c7d03",
  null
  
)

export default component.exports